import React from 'react';
import {BrowserRouter as Router , Route, Switch,Redirect} from  'react-router-dom';
import routes from 'config/routes';
import 'assets/scss/styles.scss';
import {getStringHash} from 'libs/utils';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import ProtectedRoute from 'components/protected'
import PageNotFound from 'pages/PageNotFound'

function App() {
  return (
      <Router>
        <Switch>
          {
            routes.map( ({path , component, exact, isProtected}) => {
              // console.log([isProtected)
              if (isProtected){
                return <ProtectedRoute
                  key={getStringHash(path)}
                  path={path}
                  exact={exact}
                  component={component}
                   />
              } else {
                return <Route
                      key={getStringHash(path)}
                      path={path}
                      exact={exact}
                      component={component}
                    />
              }
              
            })
          }
          <Route path="/404" component={PageNotFound} />
          <Redirect to={{pathname: '/404'}}/>
        </Switch>
      </Router>
  );
}

export default App;
